import {
  Tag,
  Text,
  Button,
  ArrowRightIcon,
  ForumIcon,
} from '@mercai/clever'

import { formatDateWithTime } from '@/helpers'

import {
  TableColumnHostNumberProps,
  TableColumnRemoteNumberProps,
  TableColumnStatusProps,
  TableColumnMessagesProps,
  TableColumnCreatedAtProps,
  TableColumnActionsProps,
} from './table-columns.type'

import styles from './table-columns.module.css'

export const TableColumnHostNumber = ({ record }: TableColumnHostNumberProps) => {

  return (
    <div className={styles['number-wrapper']}>
      <Text>{record?.hostNumber}</Text>
    </div>
  )
}


export const TableColumnRemoteNumber = ({ record }: TableColumnRemoteNumberProps) => {

  return (
    <div className={styles['number-wrapper']}>
      <Text>{record?.remoteNumber}</Text>
    </div>
  )
}

export const TableColumnStatus = ({ value }: TableColumnStatusProps) => {
  return (
    <Tag variant={value === 'pending' ? 'warning' : 'success'} model="outline">
      {value}
    </Tag>
  )
}

export const TableColumnMessages = ({ value }: TableColumnMessagesProps) => {
  return <span>{value?.length} messages</span>
}

export const TableColumnCreatedAt = ({ value }: TableColumnCreatedAtProps) => {
  if (!value) {
    return <span>-</span>
  }

  const [date, time] = formatDateWithTime(value)?.split(' ')

  return (
    <div className={styles['created-at-wrapper']}>
      <Text variant="title-base">{date}</Text>
      <Text variant="text-small">{time}</Text>
    </div>
  )
}

export const TableColumnActions = ({
  record,
  onHandleEditRegister,
  onHandleShowRegister,
}: TableColumnActionsProps) => {

  return (
    <div className={styles['action-buttons']}>
      <Button
        variant="secondary"
        model="square"
        onClick={() => onHandleEditRegister(record.uuid || '')}
      >
        <ForumIcon />
      </Button>


      <Button
        variant="primary"
        onClick={() => onHandleShowRegister(record.uuid || '')}
        model="square"
      >
        <ArrowRightIcon />
      </Button>


    </div>
  )
}